/**
 * P-34 (D-184, D-188) - the warning (never a block) under the server fields of every
 * engagement form: a COST with no price is a server the customer is not charged for;
 * a price BELOW the cost is a loss. Pure; unit-tested (`serverTerms.test.ts`).
 */
export type ServerTermsWarningKey = 'costNoFee' | 'feeBelowCost';

const toNum = (v: unknown): number | null => {
  if (v === null || v === undefined) return null;
  const s = String(v).trim().replace(',', '.');
  if (s === '') return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
};

export function serverTermsWarning(fee: unknown, cost: unknown): ServerTermsWarningKey | null {
  const f = toNum(fee) ?? 0;
  const c = toNum(cost) ?? 0;
  if (c > 0 && f <= 0) return 'costNoFee';
  if (f > 0 && c > f) return 'feeBelowCost';
  return null;
}
